import { action, observable, makeObservable } from 'mobx';
import {contentLoaders, SuccessResponse} from '../../../../domain';
import {HttpPromiseState, SaveStateHolder} from '../../../../lib/helpers';

export class DeleteUnitStore implements SaveStateHolder {
  @observable.ref
  save: HttpPromiseState<SuccessResponse> | null;

  constructor(readonly unitId: number) {
    makeObservable(this);
    this.unitId = unitId;
    this.save = null;
  }

  @action
  complete() {
    if (this.save?.isPending === true)
      return;
    this.save = contentLoaders.x4unit.delete(this.unitId);
  }
}
